import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types';
import smoothscroll from 'smoothscroll-polyfill';
import {useIsMounted} from 'hooks';
import style from './style.scss'; //NOSONAR

let clickPosition = 0;

const Slider = (props) => {
    const [left, setLeft] = useState(false);
    const [right, setRight] = useState(true);
    const [withArrows, setWithArrows] = useState(true);
    const isMounted = useIsMounted();

    const arrows = props.arrows ? props.arrows : false;
    const scroller = useRef(null);

    useEffect(() => {
        if(props.currentSlide > 0){
            const scrollInitial = scroller ? ((scroller.current.scrollLeft + scroller.current.offsetWidth) * props.currentSlide) : 0;
            scroller.current.scrollTo({top: 0, left: scrollInitial, behavior: 'smooth'});

            setLeft(true);


            if(props.currentSlide >= (Math.round(props.children.length/6) - 1)){
                setRight(false);
            }
        } else {
            if(scroller.current.scrollTo){
                scroller.current.scrollTo({top: 0, left: -200, behavior: 'auto'});
            }
        }
    },[props.currentSlide]);

    useEffect(() => {
        smoothscroll.polyfill();
        initArrows();

        if(typeof window !== 'undefined'){
            window.addEventListener('resize', verifyArrows);
        }
        return function cleanup(){
            clickPosition = 0;
            if (typeof window !== 'undefined') {
                window.removeEventListener("resize", verifyArrows);
            }
        }
    }, []);

    const initArrows = () => {
        const response = verifyArrows();

        if(!response){
            setTimeout(() => {
                if(isMounted.current){
                    initArrows();
                }
            }, 50);
        }
    }

    const verifyArrows = () => {
        const element = scroller.current;
        if(element.clientWidth === 0) return false;

        const withArrowsAux = element && element.clientWidth !== element.scrollWidth;

        if(withArrowsAux !== withArrows){
            setWithArrows(withArrowsAux);
        }

        return true;
    }

    const scrollNext = () => {
        if(!window) return false;
        const element = scroller.current;
        const item = element.children[0];
        const itemStyle = window.getComputedStyle(item);
        const margin = parseInt(itemStyle.marginLeft) + parseInt(itemStyle.marginRight);
        const posInit = element.scrollLeft;
        const itemWidth = item.offsetWidth + margin;
        const widthMove = element.clientWidth < itemWidth ? (parseFloat(element.clientWidth / itemWidth) * itemWidth) : (Math.trunc(element.clientWidth / itemWidth) * itemWidth);
        const widthCalc = widthMove + posInit;
        const proxLimit = widthCalc + widthMove + 5;

        if(element.scrollWidth <= widthCalc) {
            element.scrollTo({top: 0, left: 0, behavior: 'smooth'});
            setLeft(false);
            setRight(true);
        } else {
            const scrollAmount = scroller ? widthCalc : 0;
            element.scrollTo({top: 0, left: scrollAmount, behavior: 'smooth'});
            setLeft(true);
        }

        if(proxLimit >= element.scrollWidth) {
            setRight(false);
        }else{
            setRight(true);
        }

        if(props.callback) {
            clickPosition = clickPosition + 1;
            props.callback(clickPosition);
        }
    }

    const scrollPrev = () => {
        if(!window) return false;
        const element = scroller.current;
        const item = element.children[0];
        const itemStyle = window.getComputedStyle(item);
        const margin = parseInt(itemStyle.marginLeft) + parseInt(itemStyle.marginRight);
        const posInit = element.scrollLeft;
        const itemWidth = item.offsetWidth + margin;
        const widthMove = element.clientWidth < itemWidth ? (parseFloat(element.clientWidth / itemWidth) * itemWidth) : (Math.trunc(element.clientWidth / itemWidth) * itemWidth);
        const widthCalc = posInit - widthMove;

        if(scroller){
            element.scrollTo({top: 0, left: widthCalc, behavior: 'smooth'});
        }

        setRight(true);

        if(widthCalc <= 0){
            setLeft(false);
        }else{
            setRight(true);
        }

        if(props.callback) {
            clickPosition = clickPosition - 1;
            if(clickPosition < 0) clickPosition = 0;

            props.callback(clickPosition);
        }
    }

    return (
        <div className={'slider ' + (props.className || '')}>
            {(withArrows && arrows) && <button className={'slider-prev-button' + (left ? ' active ' : '')} onClick={scrollPrev} aria-label="slider prev button"/>}
            <div className="slides" ref={scroller}>
                {props.children}
            </div>
            {(withArrows && arrows) && <button className={'slider-next-button' + (right ? ' active ' : '')} onClick={scrollNext} aria-label="slider next button"/>}
        </div>
    )

}

Slider.propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    nav: PropTypes.bool,
    arrows: PropTypes.bool,
    currentSlide: PropTypes.number,
    callback: PropTypes.func
};

export default Slider;
